// Veb-ilovalar — xizmat sahifasi kontenti (uz / ru)
// SEO: "veb-ilova yaratish", "veb ilova narxi", "onlayn platforma",
// "shaxsiy kabinet", "SaaS ilova", "portal yaratish", "brauzerda ishlaydigan tizim".

const uz = {
    meta: {
        title: "Veb-ilova yaratish — onlayn platforma va portal, 25 mln so'mdan",
        description:
            "Veb-ilova yaratish 25 mln so'mdan: shaxsiy kabinet, portal, SaaS platforma va brauzerda ishlaydigan murakkab tizimlar. Rollar, to'lov, integratsiya va hisobotlar bilan.",
        keywords: [
            "veb-ilova yaratish",
            "veb ilova narxi",
            "onlayn platforma yaratish",
            "shaxsiy kabinet yaratish",
            "saas platforma ishlab chiqish",
            "portal yaratish",
            "brauzerda ishlaydigan tizim",
            "web application Toshkent",
        ],
    },
    hero: {
        eyebrow: "Veb-ilovalar / Platforma va portal",
        h1: "Veb-ilova yaratish — brauzerda ishlaydigan tizim",
        lead:
            "Veb-ilova — havolani ochib kiriladigan to'laqonli dastur. Hech narsa o'rnatilmaydi, yangilanish hammaga bir vaqtda yetadi, ma'lumot esa bitta bazada saqlanadi. Shaxsiy kabinet, hamkorlar portali, ta'lim platformasi yoki SaaS mahsuloti — hammasi shu asosda quriladi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "O'rnatish talab qilinmaydi",
            "API asosida — mobil ilova keyin qo'shiladi",
            "Rollar va kirish huquqlari nazorati",
            "Kod va ma'lumotlar bazasi sizniki",
        ],
    },
    intro: {
        h: "Veb-ilova nima va u oddiy saytdan nimasi bilan farq qiladi?",
        p: [
            "Sayt ma'lumot ko'rsatadi: siz o'qiysiz, rasmga qaraysiz, ariza qoldirasiz. Veb-ilova esa ish bajaradi. Foydalanuvchi tizimga kiradi, ma'lumot yaratadi va o'zgartiradi, hisob-kitob qiladi, hujjat shakllantiradi, boshqa foydalanuvchilar bilan bitta jarayonda harakat qiladi. Ya'ni bu brauzerda ochiladigan dastur, sahifalar to'plami emas.",
            "Farqni oddiy misolda ko'rish mumkin. Sayt narx ro'yxatini ko'rsatadi, veb-ilova esa mijozga o'z buyurtmalarini ochadi, qarzdorlikni hisoblaydi, hisob-fakturani chiqaradi va to'lovni qabul qiladi. Birinchisida menejer qo'ng'iroqqa javob beradi, ikkinchisida mijoz o'zi ko'radi va menejer vaqti bo'shaydi.",
            "Kompyuterga o'rnatiladigan dasturdan farqi ham katta. Veb-ilovani yangilash uchun xodimlarning kompyuteriga bormaysiz, versiyalar bir-biriga mos kelmasligi muammosi tugaydi, ma'lumot bitta joyda turadi va istalgan qurilmadan kiriladi. Boshqa shahardagi filial ham, uydagi mijoz ham xuddi shu tizimda ishlaydi.",
            "Biz veb-ilovani API asosida quramiz. Frontend React yoki Next.js'da, backend Nest.js'da, baza esa PostgreSQL'da bo'ladi. Bu tanlov muhim: keyinchalik mobil ilova yoki kassa dasturi qo'shmoqchi bo'lsangiz, ular mavjud API ustiga qo'yiladi. Tizim noldan qayta yozilmaydi va ma'lumotlar bazasi bitta bo'lib qoladi.",
            "Shu bilan birga har bir vazifa veb-ilova talab qilmaydi. Agar sizga faqat xizmatlarni ko'rsatish va ariza yig'ish kerak bo'lsa, korporativ sayt ancha arzon va tezroq tayyor bo'ladi. Uskuna bilan ishlash yoki internetsiz rejim kerak bo'lsa, desktop ilova to'g'ri tanlov. Konsultatsiyada buni ochiq aytamiz.",
            "Loyihani bir zarbada emas, bosqichma-bosqich boshlashni tavsiya qilamiz. Birinchi versiyaga eng og'riqli jarayonni kiritamiz va uni 2–3 oyda ishga tushiramiz. Xodimlar tizimda ishlay boshlagach, qaysi funksiya haqiqatan kerakligi ma'lum bo'ladi. Shundan keyin ikkinchi bosqich rejalashtiriladi — bu yondashuv byudjetni ham, keraksiz ishni ham qisqartiradi.",
        ],
    },
    definition: {
        term: "Veb-ilova nima?",
        text:
            "Veb-ilova — brauzerda ishlaydigan to'laqonli dastur. Foydalanuvchi tizimga kirib ma'lumot yaratadi, o'zgartiradi va u bilan ishlaydi; kompyuterga hech narsa o'rnatish talab qilinmaydi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Quyidagilar keyin alohida hisoblanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va jarayonni tahlil qilish",
            "Foydalanuvchi stsenariylari va funksiyalar ro'yxati",
            "Figma'da interfeys dizayni va interaktiv prototip",
            "Ro'yxatdan o'tish, kirish va parolni tiklash",
            "Rollar tizimi va kirish huquqlarini boshqarish",
            "Administrator paneli va hisobotlar",
            "API asosidagi arxitektura — mobil ilovaga tayyor",
            "Mobil brauzerda to'liq moslashuvchan interfeys",
            "Serverga joylashtirish, domen va SSL sertifikati",
            "Avtomatik zaxira nusxa va monitoring",
            "Texnik hujjatlar va foydalanuvchi qo'llanmasi",
            "Git repozitoriysi va kodning to'liq mulkchiligi sizda",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Veb-ilova biznesga nima beradi",
        sub: "Bu sayt emas, kundalik ish quroli. Quyida u aniq qaysi muammolarni yopib berishi keltirilgan.",
        items: [
            {
                t: "Qayerdan bo'lsa ham ishlash",
                d: "Ofis, uy, filial yoki safar — brauzer bo'lsa yetarli. Xodim bitta kompyuterga bog'lanib qolmaydi, yangi ish o'rni ochish esa bir necha daqiqalik vazifaga aylanadi.",
            },
            {
                t: "Yangilash og'rig'i yo'q",
                d: "Yangi versiya serverga chiqarilishi bilan hamma foydalanuvchida paydo bo'ladi. «Menda eski versiya turibdi» degan muammo va ish o'rinlarini aylanib chiqish zarurati tugaydi.",
            },
            {
                t: "Bitta ma'lumot manbasi",
                d: "Hamma bitta bazada ishlaydi. Excel fayllarini pochta orqali yuborish, versiyalarni solishtirish va qaysi raqam to'g'ri ekanini aniqlash bilan vaqt yo'qotilmaydi.",
            },
            {
                t: "Kirish huquqlari nazorat ostida",
                d: "Kim nimani ko'radi va o'zgartira oladi — administrator hal qiladi. Xodim ishdan ketsa, kirish bir bosishda yopiladi va u olib ketadigan ma'lumot qolmaydi.",
            },
            {
                t: "Mijozning o'zi xizmat qiladi",
                d: "Shaxsiy kabinetda mijoz buyurtma holatini, hisob-fakturani va qarzdorlikni o'zi ko'radi. Menejerga tushadigan bir xil savollar soni sezilarli kamayadi.",
            },
            {
                t: "Qo'lda ishlar kamayadi",
                d: "Hisob-kitob, hujjat shakllantirish, xabar yuborish va hisobot yig'ish avtomatlashtiriladi. Xodim ma'lumot ko'chirish bilan emas, qaror qabul qilish bilan shug'ullanadi.",
            },
            {
                t: "Mobil ilovaga tayyor",
                d: "Tizim API asosida qurilgani uchun mobil ilova yoki Telegram bot keyinchalik shu backend ustiga qo'shiladi. Ikkinchi marta noldan qurish va ikkinchi byudjet kerak bo'lmaydi.",
            },
            {
                t: "O'sishga chidaydi",
                d: "Foydalanuvchi va ma'lumot hajmi ortganda server quvvatini oshirish yetarli bo'ladi. Arxitektura shunga qarab tanlanadi, shuning uchun tizimni qayta yozish kerak bo'lmaydi.",
            },
            {
                t: "Har bir harakat qayd etiladi",
                d: "Kim qachon nimani o'zgartirgani jurnalda saqlanadi. Bahsli holatda tarixni ochib ko'rasiz, xatoni topasiz va oldingi holatga qaytarasiz. Moliyaviy hujjatlar bilan ishlaganda bu majburiy talab.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlar buyurtma qiladi",
        h: "Qanaqa vazifalar uchun veb-ilova quriladi",
        sub: "Foydalanuvchi shunchaki o'qimaydi, balki tizim bilan ishlaydigan holatlar.",
        items: [
            {
                t: "Mijozlar uchun shaxsiy kabinet",
                d: "Buyurtmalar, to'lovlar, hujjatlar va murojaatlar — mijoz o'zi ko'radi va boshqaradi.",
            },
            {
                t: "Dilerlar va hamkorlar portali",
                d: "Individual narx ro'yxati, onlayn buyurtma, qarzdorlik, hisob-faktura va yetkazib berish holati.",
            },
            {
                t: "Ta'lim platformalari",
                d: "Kurslar, video darslar, testlar, davomat, sertifikat va o'qituvchi kabineti.",
            },
            {
                t: "Bron va navbat tizimlari",
                d: "Vaqt tanlash, tasdiqlash, eslatma yuborish va band vaqtlar taqvimi.",
            },
            {
                t: "SaaS mahsulotlari",
                d: "Obuna asosidagi platforma: tariflar, sinov muddati, avtomatik to'lov va mijoz tashkilotlari.",
            },
            {
                t: "Ichki boshqaruv tizimlari",
                d: "Vazifalar, tasdiqlash zanjiri, hujjat aylanishi va bo'limlar bo'yicha hisobotlar.",
            },
            {
                t: "Marketpleys va xizmat platformalari",
                d: "Sotuvchi va xaridor, e'lonlar, komissiya hisobi hamda reyting tizimi.",
            },
            {
                t: "Analitika va hisobot panellari",
                d: "Bir nechta manbadan ma'lumot yig'ish, ko'rsatkichlar paneli va jadval bo'yicha avtomatik hisobotlar.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Veb-ilova narxi — uchta tarif",
        sub: "Narx funksiyalar soniga, rollar tuzilmasiga va tashqi tizimlar bilan integratsiya murakkabligiga bog'liq.",
        note:
            "Yakuniy hisob-kitob funksiyalar ro'yxati kelishilgandan keyin tasdiqlanadi. To'lov sprintlar bo'yicha bosqichma-bosqich amalga oshiriladi. Domen, server va uchinchi tomon xizmatlari (SMS shlyuz, to'lov tizimi komissiyasi) provayderga to'g'ridan-to'g'ri to'lanadi.",
        tiers: [
            {
                name: "Start",
                tagline: "Shaxsiy kabinet yoki bitta jarayon uchun platforma",
                price: "25 000 000",
                priceNote: "so'mdan",
                term: "1,5–3 oy",
                best: "Mijoz kabineti yoki bitta bo'lim ishini onlayn ko'chirmoqchi bo'lganlarga",
                features: [
                    "Individual dizayn va interaktiv prototip",
                    "Ro'yxatdan o'tish, kirish va profil",
                    "2–3 ta rol va kirish huquqlari",
                    "6–10 ta asosiy ekran va ish stsenariysi",
                    "Ma'lumotlarni qidirish, filtrlash va eksport qilish",
                    "Administrator paneli va asosiy hisobotlar",
                    "E-mail va Telegram orqali bildirishnomalar",
                    "Serverga joylashtirish, domen va SSL",
                    "3 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Business",
                tagline: "To'lov va integratsiyali to'laqonli platforma",
                price: "50 000 000",
                priceNote: "so'mdan",
                term: "3–6 oy",
                best: "Ko'p rolli portal, ta'lim platformasi yoki hamkorlar tizimi uchun",
                featured: true,
                features: [
                    "Start tarifidagi hamma narsa",
                    "15–30 ta ekran va murakkab biznes-mantiq",
                    "Onlayn to'lov: Payme, Click, Uzum va bank kartasi",
                    "Ko'p rolli tizim va bo'limlar bo'yicha huquqlar",
                    "CRM, 1C, ERP yoki tashqi API bilan integratsiya",
                    "Hujjat shakllantirish: PDF, Excel va chop etish shakllari",
                    "Analitika paneli va moslashtiriladigan hisobotlar",
                    "Harakatlar jurnali (audit log) va ikki bosqichli kirish",
                    "Ko'p tillilik va SEO'ga ochiq ommaviy bo'lim",
                    "Texnik hujjatlar va 6 oylik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Enterprise",
                tagline: "SaaS mahsuloti va yuqori yuklama uchun",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Obuna modeli, ko'p tashkilotli tizim yoki katta yuklamali platformalarga",
                features: [
                    "Ko'p tashkilotli (multi-tenant) arxitektura",
                    "Obuna, tariflar, sinov muddati va avtomatik hisob-kitob",
                    "Yuqori yuklamaga mo'ljallangan infratuzilma va keshlash",
                    "Sun'iy intellekt modullari: tavsiya, qidiruv, matn tahlili",
                    "Real vaqt rejimi: chat, bildirishnoma, jonli yangilanish",
                    "Xavfsizlik auditi va shaxsiy ma'lumotlar himoyasi",
                    "CI/CD, avtotestlar va monitoring tizimi",
                    "Doimiy mahsulot jamoasi va kelishilgan SLA",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Veb-ilova qanday quriladi",
        sub: "Sprintlar bo'yicha ishlaymiz — har 2 haftada sinov muhitiga kirib, tayyor bo'lgan qismni o'zingiz ko'rib chiqasiz.",
        steps: [
            {
                t: "Jarayonni tahlil qilish",
                d: "Bugun ish qanday yurishini yozib chiqamiz: kim nima kiritadi, qaysi bosqich vaqt yeydi, qanday hisobot kerak. Shu asosda funksiyalar ro'yxati va aniq narx shakllanadi.",
                time: "1–2 hafta",
            },
            {
                t: "Arxitektura va ma'lumotlar tuzilmasi",
                d: "Baza sxemasi, rollar, API va integratsiyalar rejalashtiriladi. To'g'ri tuzilma keyinchalik yangi funksiya qo'shishni arzon va tez qiladi.",
                time: "1 hafta",
            },
            {
                t: "Dizayn va prototip",
                d: "Ekranlar Figma'da chiziladi va interaktiv prototip yig'iladi. Siz uni bosib ko'rasiz — mantiqdagi xatolar kod yozilmasidan oldin tuzatiladi.",
                time: "2–4 hafta",
            },
            {
                t: "Backend va API",
                d: "Ma'lumotlar bazasi, biznes-mantiq va API quriladi. Tashqi tizimlar bilan integratsiya ham shu bosqichda sinovdan o'tkaziladi.",
                time: "3–6 hafta",
            },
            {
                t: "Interfeysni dasturlash",
                d: "Ekranlar navbat bilan yig'iladi va har sprint oxirida sinov muhitiga chiqariladi. Siz haqiqiy ma'lumot bilan ishlab ko'rib, fikr bildirasiz.",
                time: "4–12 hafta",
            },
            {
                t: "Sinov va tezlikni sozlash",
                d: "Stsenariylar, rollar, xavfsizlik va yuklama tekshiriladi. Sahifa yuklanish tezligi va mobil brauzerdagi ishlashi alohida sozlanadi.",
                time: "1–3 hafta",
            },
            {
                t: "Ishga tushirish va o'qitish",
                d: "Tizimni ishchi serverga chiqaramiz, eski bazadan ma'lumot ko'chiramiz, xodimlarni o'qitamiz va birinchi haftalarda yonma-yon turib yordam beramiz.",
                time: "1–2 hafta",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan platformalar",
        sub: "Har bir loyiha noldan qurilgan: mahsulot mantiqi, interfeys dizayni va texnik qismi bizning jamoamizda tayyorlangan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["elma-lms", "imtihan", "myyurist", "logistatrans", "ung-academy", "anibla"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Veb-ilova bo'yicha ko'p beriladigan savollar",
        sub: "Buyurtmadan oldin eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Veb-ilova yaratish qancha turadi?",
                a: "Narx 25 000 000 so'mdan boshlanadi. Bazaviy tarifga kirish tizimi, 2–3 ta rol, 6–10 ta ekran, admin panel va hisobotlar kiradi. Onlayn to'lov, murakkab biznes-mantiq va tashqi tizimlar bilan integratsiya kerak bo'lsa, tarif 50 000 000 so'mdan boshlanadi. Aniq raqam funksiyalar ro'yxati kelishilgandan keyin belgilanadi.",
            },
            {
                q: "Veb-ilova bilan oddiy sayt orasidagi farq nima?",
                a: "Sayt ma'lumot ko'rsatadi va ariza yig'adi. Veb-ilovada foydalanuvchi tizimga kiradi, ma'lumot yaratadi va o'zgartiradi, hisob-kitob qiladi va hujjat oladi. Shuning uchun ularning arxitekturasi, hajmi va narxi ham boshqacha. Agar sizga faqat kompaniya haqida ma'lumot kerak bo'lsa, korporativ sayt arzonroq yechim bo'ladi va uni ikki-uch haftada ishga tushirish mumkin.",
            },
            {
                q: "Veb-ilova qancha vaqtda tayyor bo'ladi?",
                a: "Start tarifi 1,5–3 oyda, Business tarifi 3–6 oyda topshiriladi. Sprintlar bo'yicha ishlaganimiz uchun tizimning ishlaydigan qismiga 3–4 haftadan keyin kirib ko'rasiz. Muddatga eng ko'p ta'sir qiladigan omil — tashqi tizimlar bilan integratsiya va sizning tomoningizda qaror qabul qilish tezligi. Dizayn tasdiqlanishi kechiksa, umumiy muddat ham shunga yarasha suriladi.",
            },
            {
                q: "Keyinchalik mobil ilova qo'shish mumkinmi?",
                a: "Ha, biz aynan shuni hisobga olib quramiz. Tizim API asosida ishlaydi, shuning uchun mobil ilova yoki Telegram bot mavjud backend ustiga qo'yiladi. Ma'lumotlar bazasi bitta bo'lib qoladi, mantiq takrorlanmaydi va mobil qism narxi noldan qurishdan ancha arzon tushadi. Amalda bu odatda faqat mobil interfeys va sinov xarajati bo'lib qoladi.",
            },
            {
                q: "Ma'lumotlar qayerda saqlanadi va xavfsizmi?",
                a: "Server va domen sizning nomingizga rasmiylashtiriladi, ma'lumotlar esa siz tanlagan joyda — O'zbekistondagi yoki xorijiy data-markazda saqlanadi. Standart tarzda SSL, rollar bo'yicha kirish nazorati, parollarni shifrlash va avtomatik zaxira nusxa sozlanadi. Talab bo'lsa, ikki bosqichli kirish va harakatlar jurnali qo'shiladi.",
            },
            {
                q: "Mavjud 1C yoki CRM tizimim bilan bog'lanadimi?",
                a: "Ha. Integratsiya odatda API orqali quriladi: tizimlar bir-biriga ma'lumot uzatadi va qo'lda ko'chirish kerak bo'lmaydi. 1C, amoCRM, Bitrix24, to'lov shlyuzlari, SMS xizmatlari va Telegram bilan ishlaymiz. Tizimingizda API bo'lmasa, uni alohida modul sifatida yozib beramiz. Integratsiya hajmi va sinov muddati loyiha boshida alohida bosqich sifatida rejalashtiriladi.",
            },
            {
                q: "Veb-ilova telefonda ishlaydimi?",
                a: "Ha, interfeys mobil brauzerga to'liq moslashtiriladi va telefon ekranida qulay ishlaydi. Qo'shimcha ravishda PWA rejimini sozlashimiz mumkin: ilova telefon ekraniga ikona sifatida qo'shiladi va kesh hisobiga tezroq ochiladi. To'liq push va oflayn rejim kerak bo'lsa, alohida mobil ilova tavsiya qilinadi.",
            },
            {
                q: "Foydalanuvchi soni ortsa, tizim ko'tara oladimi?",
                a: "Arxitektura shuni hisobga olib tanlanadi: baza indekslanadi, tez-tez so'raladigan ma'lumot keshlanadi, og'ir jarayonlar fonga chiqariladi. Yuklama oshganda ko'p hollarda server quvvatini oshirish yetarli bo'ladi. Enterprise tarifida yuklama testi va monitoring alohida bosqich sifatida bajariladi, shuning uchun tizim chegarasi taxmin emas, o'lchangan raqam bilan ma'lum bo'ladi.",
            },
            {
                q: "Kod va ma'lumotlar bazasi kimga tegishli?",
                a: "Sizga. Loyiha sizning Git repozitoriyingizda olib boriladi, server va domen ham sizning nomingizga ochiladi. Topshirishda kod, texnik hujjatlar va barcha kirish ma'lumotlari to'liq sizga o'tadi. Kelajakda boshqa jamoa bilan davom etmoqchi bo'lsangiz, hech qanday bog'liqlik qolmaydi. Kodni yopiq saqlash yoki litsenziya orqali bog'lab qo'yish amaliyoti bizda yo'q.",
            },
            {
                q: "Ishga tushgandan keyin nima bo'ladi?",
                a: "Start tarifida 3 oy, Business tarifida 6 oy qo'llab-quvvatlash narxga kiradi: xatolar bepul tuzatiladi, xodimlar savollariga javob beramiz. Keyin oylik texnik xizmat shartnomasini taklif qilamiz — monitoring, zaxira nusxa nazorati, xavfsizlik yangilanishlari va kelishilgan hajmdagi kichik o'zgarishlar. Katta yangi modullar alohida loyiha sifatida baholanadi.",
            },
        ],
    },
    cta: {
        h: "Platformangizni birga rejalashtiramizmi?",
        p: "Bepul konsultatsiyada jarayoningizni ko'rib chiqamiz va sizga veb-ilova kerakmi yoki sayt yetarlimi — ochiq aytamiz. Keyin funksiyalar ro'yxati, aniq narx va muddatni yozma taklifda beramiz. Qo'ng'iroq qiling: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },
    images: [
        {
            src: "/assets/img/projects/elma-lms.webp",
            alt: "ELMA veb-ilovasi — xodimlarni o'qitish platformasining brauzerdagi interfeysi",
            caption: "ELMA — xodimlarni o'qitish platformasi: kurslar, testlar va natijalar paneli.",
        },
        {
            src: "/assets/img/projects/imtihan.webp",
            alt: "Imtihan platformasi — onlayn test va bilim baholash veb-ilovasi ekrani",
            caption: "Imtihan — onlayn testlash platformasi: savollar bazasi, urinishlar va natija tahlili.",
        },
        {
            src: "/assets/img/projects/myyurist.webp",
            alt: "My Yurist veb-platformasi — onlayn yuridik xizmat kabineti interfeysi",
            caption: "My Yurist — mijoz kabineti, murojaatlar oqimi va onlayn to'lov bitta tizimda.",
        },
        {
            src: "/assets/img/projects/logistatrans.webp",
            alt: "Logistatrans veb-ilovasi — logistika buyurtmalari va marshrutlarni boshqarish tizimi interfeysi",
            caption: "Logistatrans — buyurtma, marshrut va hujjatlar bitta veb-tizimda boshqariladi.",
        },
        {
            src: "/assets/img/projects/ung-academy.webp",
            alt: "UNG Academy ta'lim platformasi — kurslar va o'quvchi kabineti interfeysi",
            caption: "UNG Academy — kurslar katalogi, ro'yxatdan o'tish va o'quvchi kabineti.",
        },
    ],
    related: ["mobil-ilova", "desktop-ilova", "crm-tizimlar", "erp-tizimlar", "biznes-avtomatlashtirish"],
};

const ru = {
    meta: {
        title: "Разработка веб-приложения — онлайн-платформа и портал, от 25 млн сум",
        description:
            "Разработка веб-приложения от 25 млн сум: личный кабинет, портал, SaaS-платформа и сложные системы в браузере. С ролями, оплатой, интеграциями и отчётами.",
        keywords: [
            "разработка веб-приложения",
            "стоимость веб-приложения",
            "создание онлайн-платформы",
            "разработка личного кабинета",
            "разработка saas платформы",
            "создание портала",
            "система в браузере",
            "web application Ташкент",
        ],
    },
    hero: {
        eyebrow: "Веб-приложения / Платформа и портал",
        h1: "Разработка веб-приложения — системы, работающей в браузере",
        lead:
            "Веб-приложение — полноценная программа, в которую заходят по ссылке. Ничего не устанавливается, обновление доходит до всех сразу, а данные хранятся в одной базе. Личный кабинет, партнёрский портал, образовательная платформа или SaaS-продукт строятся на этой основе.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Установка не требуется",
            "Архитектура на API — мобильное приложение можно добавить позже",
            "Контроль ролей и прав доступа",
            "Код и база данных — ваши",
        ],
    },
    intro: {
        h: "Что такое веб-приложение и чем оно отличается от обычного сайта",
        p: [
            "Сайт показывает информацию: вы читаете, смотрите фотографии, оставляете заявку. Веб-приложение выполняет работу. Пользователь входит в систему, создаёт и меняет данные, считает, формирует документы и участвует в общем процессе вместе с другими людьми. То есть это программа в браузере, а не набор страниц.",
            "Разницу проще показать на примере. Сайт показывает прайс-лист, а веб-приложение открывает клиенту его заказы, считает задолженность, выставляет счёт и принимает оплату. В первом случае на звонки отвечает менеджер, во втором — клиент видит всё сам, а время менеджера освобождается.",
            "От программы, установленной на компьютер, отличия тоже существенные. Чтобы обновить веб-приложение, не нужно обходить рабочие места; проблема несовпадающих версий исчезает, данные лежат в одном месте, а вход возможен с любого устройства. Филиал в другом городе и клиент из дома работают в одной системе.",
            "Мы строим веб-приложения на базе API. Фронтенд на React или Next.js, бэкенд на Nest.js, база — PostgreSQL. Этот выбор важен: если позже понадобится мобильное приложение или кассовая программа, они лягут поверх существующего API. Систему не придётся переписывать, а база данных останется одна.",
            "При этом не каждая задача требует веб-приложения. Если нужно просто показать услуги и собирать заявки, корпоративный сайт обойдётся дешевле и выйдет быстрее. Если нужна работа с оборудованием или режим без интернета, правильный выбор — десктопное приложение. На консультации мы говорим об этом прямо.",
            "Запускать проект советуем не одним рывком, а этапами. В первую версию берём самый болезненный процесс и выводим его в работу за 2–3 месяца. Когда сотрудники начинают пользоваться системой, становится понятно, какие функции нужны на самом деле. Только после этого планируем второй этап — так короче срок и меньше лишней работы.",
        ],
    },
    definition: {
        term: "Что такое веб-приложение?",
        text:
            "Веб-приложение — полноценная программа, работающая в браузере. Пользователь входит в систему, создаёт и изменяет данные и работает с ними; устанавливать что-либо на компьютер не требуется.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не дополнения, которые считаются отдельно — всё перечисленное есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и разбор процесса",
            "Пользовательские сценарии и список функций",
            "Дизайн интерфейса и интерактивный прототип в Figma",
            "Регистрация, вход и восстановление пароля",
            "Система ролей и управление правами доступа",
            "Панель администратора и отчёты",
            "Архитектура на API — готовность к мобильному приложению",
            "Полностью адаптивный интерфейс в мобильном браузере",
            "Размещение на сервере, домен и SSL-сертификат",
            "Автоматическое резервное копирование и мониторинг",
            "Техническая документация и руководство пользователя",
            "Git-репозиторий и полное владение кодом на вашей стороне",
        ],
    },
    benefits: {
        eyebrow: "Зачем нужно",
        h: "Что веб-приложение даёт бизнесу",
        sub: "Это не сайт, а рабочий инструмент. Ниже — какие задачи он закрывает.",
        items: [
            {
                t: "Работа из любой точки",
                d: "Офис, дом, филиал или командировка — достаточно браузера. Сотрудник не привязан к одному компьютеру, а открытие нового рабочего места занимает несколько минут.",
            },
            {
                t: "Никакой возни с обновлениями",
                d: "Новая версия появляется у всех пользователей сразу после выката на сервер. Проблема «у меня стоит старая версия» и необходимость обходить рабочие места исчезают.",
            },
            {
                t: "Один источник данных",
                d: "Все работают в одной базе. Не нужно пересылать Excel по почте, сверять версии файлов и выяснять, какая из цифр в итоге правильная.",
            },
            {
                t: "Права доступа под контролем",
                d: "Кто что видит и может изменить, решает администратор. Когда сотрудник уходит, доступ закрывается одним действием, и он не уносит с собой никаких данных.",
            },
            {
                t: "Клиент обслуживает себя сам",
                d: "В личном кабинете клиент сам видит статус заказа, счета и задолженность. Количество однотипных вопросов, которые доходят до менеджера, заметно снижается.",
            },
            {
                t: "Меньше ручной работы",
                d: "Расчёты, формирование документов, рассылки и сбор отчётов автоматизируются. Сотрудник занимается решениями, а не переносом данных из одной таблицы в другую.",
            },
            {
                t: "Готовность к мобильному приложению",
                d: "Система построена на API, поэтому мобильное приложение или Telegram-бот добавляются поверх того же бэкенда. Не придётся строить всё с нуля второй раз и закладывать ещё один бюджет.",
            },
            {
                t: "Запас на рост",
                d: "Когда число пользователей и объём данных растут, чаще всего достаточно увеличить мощность сервера. Архитектура выбирается с учётом этого, поэтому переписывать систему не нужно.",
            },
            {
                t: "Каждое действие фиксируется",
                d: "Кто, когда и что изменил — всё сохраняется в журнале. В спорной ситуации вы открываете историю, находите ошибку и возвращаете прежнее состояние. При работе с финансовыми документами это обязательное требование.",
            },
        ],
    },
    audience: {
        eyebrow: "Кто заказывает",
        h: "Под какие задачи делают веб-приложение",
        sub: "Случаи, когда пользователь не просто читает, а работает с системой.",
        items: [
            {
                t: "Личный кабинет для клиентов",
                d: "Заказы, платежи, документы и обращения — клиент всё видит и всем управляет сам.",
            },
            {
                t: "Портал дилеров и партнёров",
                d: "Индивидуальный прайс, онлайн-заказ, задолженность, счета и статус отгрузки.",
            },
            {
                t: "Образовательные платформы",
                d: "Курсы, видеоуроки, тесты, посещаемость, сертификаты и кабинет преподавателя.",
            },
            {
                t: "Системы бронирования и записи",
                d: "Выбор времени, подтверждение, напоминания и календарь занятых слотов.",
            },
            {
                t: "SaaS-продукты",
                d: "Платформа по подписке: тарифы, пробный период, автосписание и клиентские организации.",
            },
            {
                t: "Внутренние системы управления",
                d: "Задачи, цепочки согласования, документооборот и отчёты по подразделениям.",
            },
            {
                t: "Маркетплейсы и сервисные платформы",
                d: "Продавец и покупатель, объявления, расчёт комиссии и система рейтингов.",
            },
            {
                t: "Панели аналитики и отчётности",
                d: "Сбор данных из нескольких источников, дашборд показателей и автоматические отчёты.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость веб-приложения — три тарифа",
        sub: "Цена зависит от количества функций и сложности интеграций.",
        note:
            "Итоговая смета подтверждается после согласования списка функций. Оплата идёт поэтапно, по спринтам. Домен, сервер и сторонние сервисы (SMS-шлюз, комиссия платёжной системы) оплачиваются провайдеру напрямую.",
        tiers: [
            {
                name: "Start",
                tagline: "Личный кабинет или платформа под один процесс",
                price: "25 000 000",
                priceNote: "сум",
                term: "1,5–3 месяца",
                best: "Тем, кто переводит в онлайн кабинет клиента или работу одного отдела",
                features: [
                    "Индивидуальный дизайн и интерактивный прототип",
                    "Регистрация, вход и профиль",
                    "2–3 роли и права доступа",
                    "6–10 основных экранов и рабочих сценариев",
                    "Поиск, фильтрация и выгрузка данных",
                    "Панель администратора и базовые отчёты",
                    "Уведомления по e-mail и в Telegram",
                    "Размещение на сервере, домен и SSL",
                    "3 месяца технической поддержки",
                ],
            },
            {
                name: "Business",
                tagline: "Полноценная платформа с оплатой и интеграциями",
                price: "50 000 000",
                priceNote: "сум",
                term: "3–6 месяцев",
                best: "Порталу с несколькими ролями, образовательной платформе или партнёрской системе",
                featured: true,
                features: [
                    "Всё, что входит в тариф Start",
                    "15–30 экранов и сложная бизнес-логика",
                    "Онлайн-оплата: Payme, Click, Uzum и банковская карта",
                    "Многоролевая система и права по подразделениям",
                    "Интеграция с CRM, 1С, ERP или внешним API",
                    "Формирование документов: PDF, Excel и печатные формы",
                    "Аналитическая панель и настраиваемые отчёты",
                    "Журнал действий (audit log) и двухфакторный вход",
                    "Мультиязычность и открытый для SEO публичный раздел",
                    "Техническая документация и 6 месяцев поддержки",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Для SaaS-продуктов и высоких нагрузок",
                price: "По договору",
                priceNote: "",
                term: "По проекту",
                best: "Подписочной модели, мультиорганизационным системам и платформам с большой нагрузкой",
                features: [
                    "Мультиарендная (multi-tenant) архитектура",
                    "Подписки, тарифы, пробный период и автоматические списания",
                    "Инфраструктура под высокую нагрузку и кеширование",
                    "Модули искусственного интеллекта: рекомендации, поиск, разбор текста",
                    "Режим реального времени: чат, уведомления, живое обновление",
                    "Аудит безопасности и защита персональных данных",
                    "CI/CD, автотесты и система мониторинга",
                    "Выделенная продуктовая команда и согласованный SLA",
                ],
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как создаётся веб-приложение",
        sub: "Работаем спринтами — каждые две недели вы заходите в систему и смотрите результат сами.",
        steps: [
            {
                t: "Анализ процесса",
                d: "Описываем, как работа идёт сегодня: кто что вносит, какой этап съедает время, какие отчёты нужны. На этой основе формируются список функций и точная цена.",
                time: "1–2 недели",
            },
            {
                t: "Архитектура и структура данных",
                d: "Планируем схему базы, роли, API и состав интеграций. При правильной структуре новые функции в будущем добавляются дешевле и быстрее.",
                time: "1 неделя",
            },
            {
                t: "Дизайн и прототип",
                d: "Экраны рисуются в Figma, из них собирается интерактивный прототип. Вы сами кликаете по прототипу — ошибки в логике исправляются до написания кода.",
                time: "2–4 недели",
            },
            {
                t: "Бэкенд и API",
                d: "Собираем базу данных, бизнес-логику и API. Интеграции с внешними системами тоже подключаются и тестируются на этом этапе.",
                time: "3–6 недель",
            },
            {
                t: "Разработка интерфейса",
                d: "Экраны собираются по очереди и в конце каждого спринта выкатываются на тестовый стенд. Вы работаете на реальных данных и даёте обратную связь.",
                time: "4–12 недель",
            },
            {
                t: "Тестирование и скорость",
                d: "Проверяем сценарии, роли, безопасность и поведение под нагрузкой. Отдельно настраиваем скорость загрузки страниц и работу в мобильном браузере.",
                time: "1–3 недели",
            },
            {
                t: "Запуск и обучение",
                d: "Выкатываем систему на рабочий сервер, переносим данные из старой базы, обучаем сотрудников и первые недели остаёмся на связи.",
                time: "1–2 недели",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Платформы, которые мы построили",
        sub: "Каждый проект с нуля: продуктовая логика, дизайн и техническая часть сделаны нашей командой.",
        cta: "Смотреть все проекты",
        slugs: ["elma-lms", "imtihan", "myyurist", "logistatrans", "ung-academy", "anibla"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы о веб-приложениях",
        sub: "Короткие ответы на то, что спрашивают чаще всего перед заказом.",
        items: [
            {
                q: "Сколько стоит разработка веб-приложения?",
                a: "Цена начинается от 25 000 000 сум. В базовый тариф входят система входа, 2–3 роли, 6–10 экранов, админ-панель и отчёты. Если нужны онлайн-оплата, сложная бизнес-логика и интеграции с внешними системами, тариф начинается от 50 000 000 сум. Точная сумма фиксируется после согласования списка функций.",
            },
            {
                q: "Чем веб-приложение отличается от обычного сайта?",
                a: "Сайт показывает информацию и собирает заявки. В веб-приложении пользователь входит в систему, создаёт и изменяет данные, считает и получает документы. Поэтому отличаются архитектура, объём работ и цена. Если вам нужна только информация о компании, корпоративный сайт обойдётся дешевле.",
            },
            {
                q: "Сколько времени занимает разработка?",
                a: "Тариф Start сдаётся за 1,5–3 месяца, Business — за 3–6 месяцев. Поскольку мы работаем спринтами, в работающую часть системы вы зайдёте уже через 3–4 недели. Больше всего на срок влияют интеграции с внешними системами и скорость принятия решений на вашей стороне. Если согласование дизайна затягивается, общий срок сдвигается ровно на это время.",
            },
            {
                q: "Можно ли позже добавить мобильное приложение?",
                a: "Да, мы строим систему именно с этим расчётом. Она работает на API, поэтому мобильное приложение или Telegram-бот подключаются к существующему бэкенду. База данных остаётся одна, логика не дублируется, и мобильная часть обходится заметно дешевле разработки с нуля. На практике в бюджет входят только мобильный интерфейс и его тестирование.",
            },
            {
                q: "Где хранятся данные и насколько это безопасно?",
                a: "Сервер и домен оформляются на вашу компанию, а данные хранятся там, где выберете вы — в дата-центре в Узбекистане или за рубежом. По умолчанию настраиваются SSL, доступ по ролям, шифрование паролей и автоматические резервные копии. По требованию добавляем двухфакторный вход, журнал действий и ограничение доступа по IP-адресам.",
            },
            {
                q: "Можно ли связать приложение с моей 1С или CRM?",
                a: "Да. Интеграция обычно строится через API: системы обмениваются данными, и ручной перенос не нужен. Работаем с 1С, amoCRM, Bitrix24, платёжными шлюзами, SMS-сервисами и Telegram. Если у вашей системы нет API, мы напишем его отдельным модулем. Объём интеграции и время на её тестирование планируются отдельным этапом в начале проекта.",
            },
            {
                q: "Будет ли веб-приложение работать на телефоне?",
                a: "Да, интерфейс полностью адаптируется под мобильный браузер и удобно работает на экране телефона. Дополнительно можем настроить режим PWA: приложение добавляется иконкой на экран и открывается быстрее за счёт кеша. Если нужны полноценные push-уведомления и работа офлайн, советуем отдельное мобильное приложение — браузер здесь ограничен возможностями операционной системы.",
            },
            {
                q: "Выдержит ли система рост числа пользователей?",
                a: "Архитектура выбирается с учётом этого: база индексируется, часто запрашиваемые данные кешируются, тяжёлые процессы выносятся в фон. При росте нагрузки в большинстве случаев достаточно увеличить мощность сервера. В тарифе Enterprise нагрузочное тестирование и мониторинг выполняются отдельным этапом, поэтому предел системы известен по измеренным цифрам, а не по предположениям.",
            },
            {
                q: "Кому принадлежат код и база данных?",
                a: "Вам. Проект ведётся в вашем Git-репозитории, сервер и домен оформляются на вашу компанию. При сдаче код, техническая документация и все доступы полностью переходят к вам. Если в будущем вы захотите продолжить с другой командой, привязки к нам не останется. Практики закрывать код или удерживать клиента лицензией у нас нет.",
            },
            {
                q: "Что происходит после запуска?",
                a: "В тариф Start входят 3 месяца поддержки, в Business — 6 месяцев: ошибки исправляются бесплатно, на вопросы сотрудников отвечаем мы. Дальше предлагаем договор на ежемесячное обслуживание — мониторинг, контроль резервных копий, обновления безопасности и согласованный объём небольших доработок. Крупные новые модули оцениваются как отдельный проект.",
            },
        ],
    },
    cta: {
        h: "Спланируем вашу платформу вместе?",
        p: "На бесплатной консультации разберём ваш процесс и честно скажем, нужно ли веб-приложение или хватит сайта. Затем пришлём письменное предложение со списком функций, точной ценой и сроком. Звоните: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },
    images: [
        {
            src: "/assets/img/projects/elma-lms.webp",
            alt: "Веб-приложение ELMA — интерфейс платформы обучения сотрудников в браузере",
            caption: "ELMA — платформа обучения сотрудников: курсы, тесты и панель результатов.",
        },
        {
            src: "/assets/img/projects/imtihan.webp",
            alt: "Платформа Imtihan — веб-приложение для онлайн-тестирования и оценки знаний",
            caption: "Imtihan — платформа онлайн-тестирования: база вопросов, попытки и разбор результатов.",
        },
        {
            src: "/assets/img/projects/myyurist.webp",
            alt: "Веб-платформа My Yurist — интерфейс кабинета онлайн-юридических услуг",
            caption: "My Yurist — кабинет клиента, поток обращений и онлайн-оплата в одной системе.",
        },
        {
            src: "/assets/img/projects/logistatrans.webp",
            alt: "Веб-приложение Logistatrans — интерфейс системы управления логистическими заказами и маршрутами",
            caption: "Logistatrans — заказы, маршруты и документы управляются в одной веб-системе.",
        },
        {
            src: "/assets/img/projects/ung-academy.webp",
            alt: "Образовательная платформа UNG Academy — каталог курсов и кабинет студента",
            caption: "UNG Academy — каталог курсов, регистрация и личный кабинет студента.",
        },
    ],
    related: ["mobil-ilova", "desktop-ilova", "crm-tizimlar", "erp-tizimlar", "biznes-avtomatlashtirish"],
};

const content = { uz, ru };

export default content;
